import { NavigationItem } from '../models/navigation-item.model';

export const APP_NAME = 'IDAP Studio';
export const APP_VERSION = '0.1.0';

export const APP_NAVIGATION_ITEMS: readonly NavigationItem[] = [
  {
    label: 'Dashboard',
    icon: 'pi pi-chart-bar',
    route: '/dashboard',
    exact: true
  },
  {
    label: 'Connectors',
    icon: 'pi pi-wifi',
    route: '/connectors/new',
    activeRoute: '/connectors'
  }
];
